import PropTypes from 'prop-types'
import React, { useMemo } from 'react'
import styled from 'styled-components'

import { removeEmptyParagraphs } from '../lib/cart/item'

export interface RenderCleanHtmlProps {
  className?: string
  htmlString?: string | null
}

const RenderCleanHtml: React.FC<RenderCleanHtmlProps> = ({ className, htmlString }) => {
  const cleanedHtml = useMemo(
    () => (htmlString ? removeEmptyParagraphs({ htmlString }) : undefined),
    [htmlString],
  )

  if (!cleanedHtml) {
    return null
  }

  return (
    <div
      className={className}
      // eslint-disable-next-line react/no-danger
      dangerouslySetInnerHTML={{
        __html: cleanedHtml,
      }}
    />
  )
}

RenderCleanHtml.defaultProps = {
  className: '',
  htmlString: null,
}

RenderCleanHtml.propTypes = {
  className: PropTypes.string,
  htmlString: PropTypes.string,
}

const StyledRenderCleanHtml = styled(RenderCleanHtml)`
  br {
    display: none;
  }
`

export default StyledRenderCleanHtml
